import React from "react";
import "./styles.scss";
import { Link } from "react-router-dom";
export default () => (
  <div className="podcast-promo-container p-lg-2">
    <p>WANT TO SHARE YOUR PODCAST WITH THE WORLD?</p>
    <div className="d-flex justify-content-center">
      <Link to="/upload/podcast" disabled className="btn btn-primary get-started-button">
        get started
      </Link>
    </div>
  </div>
);
